import * as React from 'react';
import { useGanttDependencyModelFieldsContext, useGanttRowHeightContext } from './../context/GanttContext';
import { dependencyCoordinates } from '../utils';
import { getter } from '@progress/kendo-react-common';
import { useGanttViewTasksContext } from '../context/GanttViewContext';
/** @hidden */
export var GanttDependency = function (props) {
    var dependency = props.dependency;
    var tasksStore = useGanttViewTasksContext()[0];
    var element = React.useRef(null);
    var dependencyModelFields = useGanttDependencyModelFieldsContext();
    var rowHeight = useGanttRowHeightContext();
    var _a = React.useState(false), display = _a[0], setDisplay = _a[1];
    var drawCanvas = function () {
        if (element.current === null || tasksStore.current === null) {
            setDisplay(false);
            return;
        }
        var fromId = tasksStore.current[getter(dependencyModelFields.fromId)(dependency)];
        var toId = tasksStore.current[getter(dependencyModelFields.toId)(dependency)];
        if (!fromId || !toId) {
            setDisplay(false);
            return;
        }
        var fromElement = fromId.element;
        var toElement = toId.element;
        if (!fromElement || !toElement) {
            setDisplay(false);
            return;
        }
        if (display === false) {
            setDisplay(true);
            return; // avoid calculating coordinates twice
        }
        var fromCoordinates = {
            top: fromElement.offsetTop + (fromElement.offsetHeight / 2),
            start: fromElement.offsetLeft,
            end: fromElement.offsetLeft + fromElement.offsetWidth
        };
        var toCoordinates = {
            top: toElement.offsetTop + (toElement.offsetHeight / 2),
            start: toElement.offsetLeft,
            end: toElement.offsetLeft + toElement.offsetWidth
        };
        var type = getter(dependencyModelFields.type)(dependency);
        var points = dependencyCoordinates(fromCoordinates, toCoordinates, rowHeight, type);
        if (points && points.length) {
            element.current.setAttribute('points', points.map(function (point) { return "".concat(point.left, ",").concat(point.top); }).join(' '));
        }
    };
    React.useEffect(drawCanvas);
    return (React.createElement("polyline", { ref: element, style: {
            display: display ? undefined : 'none'
        } }));
};
GanttDependency.displayName = 'KendoReactGanttDependency';
